import { css } from '@emotion/css';
import { ColorConstant, Font, FontWeight, ScreenBreakpoint, Spacing } from 'src/styles';

export const mobileUserInfoWrapper = css`
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  margin-bottom: 24px;
`;

// AccountValue component
export const accountValueContainer = css`
  ${Font.h1}
`;

export const accountValue = css`
  ${FontWeight.semibold}
  color: ${ColorConstant.GREEN7};
`;

export const accountLabel = css`
  color: ${ColorConstant.GRAY7};
`;

// AccountHolderFullName component
export const fullName = css`
  ${Font.h1}
  ${FontWeight.semibold}
`;

export const accountType = css`
  ${Font.md}
  color: ${ColorConstant.GRAY8};
`;

// UserInfo
export const iconContainer = css`
  width: 32px;
  height: 32px;
  ${FontWeight.normal}
`;

export const menuSubtitle = css`
  ${Spacing.pl24}
  ${Spacing.py8}
  ${Spacing.mb8}
  color: ${ColorConstant.GRAY7};
  ${Font.sm}

  @media (max-width: ${ScreenBreakpoint.laptop.max}) {
    ${Spacing.pl0}
  }
`;
